import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/commons/Modal";
import SuccessMessage from "components/commons/SuccessMessage";
import { useCreateCostRefundMutation } from "../api/costRefundApiSlice";
import CostRefundForm from "../views/CostRefundForm";

export default function CostRefundRequestModal() {


    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const [formData, setFormData] = useState()

    let content

    const [
        sendRequest, {
            isLoading: sendingIsLoading,
            isSuccess: sendingIsSuccess }
    ] = useCreateCostRefundMutation()


    function handleRequestSending() {
        const [startDate, endDate] = formData.dateRange;
        const startEpoch = new Date(startDate).getTime() / 1000;
        const endEpoch = new Date(endDate).getTime() / 1000;
    
        const requestPayload = new FormData(); // Usa FormData per includere i file
        requestPayload.append("costRefundRequestDto",  new Blob([JSON.stringify({
            title: formData.title,
            isKmMode: formData.isKmMode,
            isAnalyticMode: formData.isAnalyticMode,
            isForfaitMode: formData.isForfaitMode,
            expenseItems: formData.expenseItems,
            distance: formData.isKmMode ? formData.distance : 0,
            startDateTime: startEpoch,
            endDateTime: endEpoch,
            notes: formData.notes,
        })], { type: 'application/json' }));
    
        // Aggiungi gli allegati al payload
        if (formData.attachments && formData.attachments.length > 0) {
            formData.attachments.forEach((file, index) => {
                requestPayload.append("attachments", file);
            });
        }
    
        // Invio della richiesta
        sendRequest(requestPayload);
    }


    content =
        <>  {
            sendingIsSuccess &&
            <SuccessMessage message={t("absenceReport:helper.send_success")} />
        }
            <Modal
                title={t("absenceReport:menu.new_costRefund_request")}
                buttonIcon={<i className="fa-solid fa-circle-plus"></i>}
                buttonLabel={t("absenceReport:menu.new_costRefund_request")}
                locked={formData == null || formData.errors.length > 0}
                isConfirm={true}
                onConfirm={handleRequestSending}
                body={
                    <>
                        <CostRefundForm onFormChange={(data) => {
                            console.log("FormData:" + JSON.stringify(data))
                            setFormData(data)
                        }} />
                    </>
                }
            />
        </>

    return content

}